import React from 'react';
import '../styles.css';
import TrophyIcon from '../../HOME/SVG/TrophyIcon';
import { useSelector, useDispatch } from 'react-redux';
import { SHOW_LEADERS } from '../../HOME/REDUX/actions';
import { YELLOW, MODE_SOLO, MODE_AI, GREEN, RED, MAGENTA, CYAN } from '../../HOME/const';
import * as f from '../logic';
import { PN_YELLOW } from '../const';
import Player from './Player';

const Scoreboard = props => {
  const dispatch = useDispatch();
  const { pn } = useSelector(state => state);
  const ai = pn.mode === MODE_AI;
  const solo = pn.mode === MODE_SOLO;
  const stats = pn.stats || {};

  //••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••
  const handleLeaders = () => {
    props.hideOptions();
    dispatch({ type: SHOW_LEADERS });
  };

  //••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••
  const renderSolo = () => {
    const grade = f.getSoloGrade(stats.aveScore, stats.plays);

    return (
      <div className="pn-scoreboard pn-scoreboard-solo">
        <div className="pn-stats" style={{ gridArea: '1/1/1/span 6' }}>
          <span>plays</span>
          <span className="pn-stats-value">{stats.plays || 0}</span>
          <span>ave.</span>
          <span className="pn-stats-value">{stats.aveScore || 0}</span>
          <span>best</span>
          <span className="pn-stats-value" style={{ marginRight: 0 }}>
            {stats.bestScore || 0}
          </span>
        </div>

        <div style={{ gridArea: '2/1', marginBottom: '-5px' }}>pairs</div>
        <div className="pn-quartz pn-score" style={{ gridArea: '2/2' }}>
          {pn.pairs || 0}
        </div>
        <div className="toolbar-button" style={{ gridArea: '2/3/2/span 2', marginTop: '10px' }} onClick={handleLeaders}>
          <TrophyIcon width="36" />
        </div>
        <div style={{ gridArea: '2/5', marginBottom: '-5px' }}>score</div>
        <div className="pn-quartz pn-score" style={{ gridArea: '2/6' }}>
          {pn.score || 0}
        </div>

        <div style={{ gridArea: '3/1', marginBottom: '-1px' }}>max</div>
        <div className="pn-sub-quartz pn-score" style={{ gridArea: '3/2' }}>
          {pn.maxPairs || 0}
        </div>
        <div className="pn-sub-quartz" style={{ gridArea: '3/3/3/span 2', color: YELLOW }}>
          {grade}
        </div>
        <div style={{ gridArea: '3/5', marginBottom: '-1px' }}>max</div>
        <div className="pn-sub-quartz pn-score" style={{ gridArea: '3/6' }}>
          {pn.maxScore || 0}
        </div>
      </div>
    );
  };

  //••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••
  const renderDuo = () => {
    if (!pn.maxPairs) {
      return null;
    }

    const className = `pn-scoreboard ${ai ? 'pn-scoreboard-ai' : 'pn-scoreboard-friend'}`;
    const foreground = ai ? (pn.skill === 1 ? GREEN : pn.skill === 2 ? PN_YELLOW : RED) : MAGENTA;
    const plays = stats.plays || 0;
    const wins = stats.wins || 0;
    const draws = stats.draws || 0;
    const grade = f.getDuoGrade(stats);
    const maxPairs1 = pn.maxPairs - (pn.oppPairs || 0);
    const maxPairs2 = pn.maxPairs - pn.pairs;

    return (
      <div className={className}>
        {/* WINS 1 */}
        <span style={{ gridArea: '1/1', color: CYAN }}>{wins}</span>
        {/* PLAYS, AVE, BEST */}
        <div className="pn-stats" style={{ gridArea: '1/1/1/span 5' }}>
          <span>plays</span>
          <span className="pn-stats-value" style={{ marginRight: `${ai ? 15 : 0}px` }}>
            {plays}
          </span>
          {ai && (
            <>
              <span>ave.</span>
              <span className="pn-stats-value">{stats.avePairs || 0}</span>
              <span>best</span>
              <span className="pn-stats-value" style={{ marginRight: 0 }}>
                {stats.bestPairs || 0}
              </span>
            </>
          )}
        </div>
        {/* WINS 2 */}
        <span style={{ gridArea: '1/5', color: foreground }}>{plays - wins - draws}</span>

        {/* PLAYER 1 */}
        <Player one="true" style={{ gridArea: '2/1/span 2/auto' }} />
        {/* PAIRS 1 */}
        <div className="pn-quartz" style={{ gridArea: '2/2', color: CYAN, margin: `${ai ? 0 : '8px 0'}` }}>
          {pn.pairs}
        </div>
        {/* TROPHY ICON */}
        {ai && (
          <div className="toolbar-button" style={{ gridArea: '2/3', marginTop: '10px' }} onClick={handleLeaders}>
            <TrophyIcon width="36" />
          </div>
        )}
        {/* PAIRS 2 */}
        <div className="pn-quartz" style={{ gridArea: '2/4', color: foreground }}>
          {pn.oppPairs || 0}
        </div>
        {/* PLAYER 2 */}
        <Player ai={ai} style={{ gridArea: '2/5/span 2/auto' }} />

        {/* MAX PAIRS 1 */}
        <div className="pn-stats" style={{ gridArea: '3/2' }}>
          <span style={{ marginBottom: '-2px' }}>max</span>
          <span className="pn-sub-quartz" style={{ marginLeft: `${maxPairs1 < 100 ? 7 : 0}px` }}>
            {maxPairs1}
          </span>
        </div>
        {/* GRADE */}
        {ai && (
          <div className="pn-sub-quartz" style={{ gridArea: '3/3', color: YELLOW }}>
            {grade}
          </div>
        )}
        {/* MAX PAIRS 2 */}
        <div className="pn-stats" style={{ gridArea: '3/4' }}>
          <span style={{ marginBottom: '-2px' }}>max</span>
          <span className="pn-sub-quartz" style={{ marginLeft: `${maxPairs2 < 100 ? 7 : 0}px` }}>
            {maxPairs2}
          </span>
        </div>
      </div>
    );
  };

  return solo ? renderSolo() : renderDuo();
};

export default Scoreboard;
